module.exports = __webpack_public_path__ + "static/img/ptld_6@2x.036db8c0.png";